// src/MeuComponente.js
import React, { useEffect, useState } from 'react';
import { SearchBar, Page } from 'components';
import Results from './components/Results';

import Api from 'services/Api';
import ApiGServer from 'services/ApiGServer';
import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import ApiMServer from 'services/ApiMServer';

const SuporteOrange = () => {
  const user = JSON.parse(localStorage.getItem('userData'))
  if (user?.permission?.remoteaccess?.read !== true) {
    window.location.replace('/home');
  }

  const [filterUnits, setFilterUnits] = useState([]);
  const [allUnits, setAllUnits] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [permission, setPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let { data } = await Api.get('/connection/connected');
        // Regex para validar ObjectId do MongoDB
        const isValidMongoId = id => /^[a-f\d]{24}$/i.test(id);

        // Filtra apenas os itens que são IDs válidos
        const filteredData = data.filter(item => isValidMongoId(item));

        if (filteredData.length === 0) {
          setLoading(false);
          return;
        }

        // Ordena os IDs (opcional)
        handleDetailUnits(filteredData.sort((a, b) => a.localeCompare(b)));
      } catch (error) {
        console.error('Erro ao buscar os dados:', error);
        setLoading(false);
      }
    };
    fetchData();

    setPermission(user?.permission?.remoteaccess);

    const interval1 = setInterval(() => {
      fetchData();
    }, 30000);
    return () => { clearInterval(interval1) };
  }, []);

  const handleDetailUnits = async (equipments) => {
    
    try {
      const [{ data }] = await Promise.all([
        ApiMServer.post(`/company/getfilterunits`, { filter: equipments })
      ]);
      console.log(data);
      setFilterUnits(data);
      setAllUnits(data);
    } catch (error) {
      console.log(error?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    if (searchData === '') {
      setAllUnits(filterUnits);
    } else {
      const equipamentsSearch = [];
      filterUnits.forEach((item) => {
        if (
          (item?.name?.toLowerCase().includes(searchData.toLowerCase())) ||
          (item?.cnpj?.toLowerCase().includes(searchData.toLowerCase())) ||
          (item?.email?.toLowerCase().includes(searchData.toLowerCase()))
        ) {
          equipamentsSearch.push(item)
        }
      });
      setAllUnits(equipamentsSearch);
    }
  };

  const handleSearchData = (e) => {
    setSearchData(e.target.value)
  };

  return (
    <Page className="p-3" title="Suporte Orange">
      <Header page={"Suporte Orange"} />

      {loading && <Reload />}

      <SearchBar
        onSearch={handleSearch}
        onSearchData={handleSearchData}
        searchData={searchData}
      />

      {allUnits && (
        <Results
          data={allUnits}
          permission={permission}
        />
      )}
    </Page >
  );
}

export default SuporteOrange;
